<template>
  <div class="page-area"><slot></slot></div>
</template>

<script>
export default {
  name: 'PageArea',
};
</script>

<style lang="scss" scoped>
  .page-area {
    width: 100%;
    padding: 2rem;
  }
</style>
